import request from "../../../../helper/request";

export const flexioServiceApi = {
  getList: (params) => {
    return request.get("/services", { params });
  }
};
